import http from '../const/http-common'

const connectDatabase = (dbInfo) => {
  return http.post('/v1/user/sql-geneartor/database', dbInfo);
}

const DatabaseService = {
  connectDatabase
}

export default DatabaseService;